import React from 'react';
import {Link} from 'react-router-dom';
import { FormGroup } from 'reactstrap';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Cropper from 'react-cropper';
import { uploadProfilePicture } from '../services'
import { toast } from 'react-toastify';

const lifeStageOptions = [
  { label: "Adolescent", value: 1 },
  { label: "Just Married", value: 2 },
  { label: "Trying to concieve", value: 3 },
  { label: "Pregnant", value: 4 },
  { label: "Already a mother", value: 5 },
  { label: "Beyond 45", value: 6 }
]

const accountForOptions = [
  { label: "Myself", value: 1 },
  { label: "Spouse", value: 2 },
  { label: "Relative", value: 3 }
]

class MyProfile extends React.Component{

  state = {
    modal: false,
    cropped: '',
    file: process.env.REACT_APP_HOST + this.props.profilePicture
  }

  componentDidMount() {

  }

  handleChange = (event) => {
    // console.log(event.target.files[0])
    let file = event.target.files[0]
    this.setState(prevState => ({
      cropImage: URL.createObjectURL(file)
    }))
    this.toggle();
  }

  _crop(){
    let croped = this.refs.cropper.getCroppedCanvas().toDataURL();
    console.log(croped)
    this.setState({croped})
  }

  toggle = () => {
    this.setState({ modal: !this.state.modal });
  };

  handleCroppedImage = async () => {
    
    let { croped } = this.state;

    console.log(croped);

    let data = {
      photo: croped
    };

    const response = await uploadProfilePicture(data);

    if(response.status !== 200) {
      return;
    }

    toast.success("Profile Picture successfully updated");

    this.toggle();
    this.setState(prevState => ({
      file: croped
    }));
    console.log(croped);
    this.props.changeAvatar(response.data.filePath);
  }

  render(){
      return(
        <div className="mb-3 row">
        <div className="text-center col-md-4">
          <FormGroup>
            <img
              className="account-image mb-2"
              src={this.state.file}
              alt=""
            />
          </FormGroup>
          {/* <p className="account-image-link">Edit</p> */}
          <FormGroup>
            <Button onClick={() => this.fileInput.click()}>Change Profile Picture</Button>
            <input style={{display: "none"}} 
              type="file" ref={fileInput => this.fileInput = fileInput}
              onChange={this.handleChange}
            />
          </FormGroup>
        </div>
        <div className="col-md-8 mt-4">
          <h4
            style={{
              fontWeight: 700,
              color: "#555555",
              marginBottom: 0,
              paddingBottom: 0
            }}
          >
            {this.props.username}
          </h4>
          {this.props.showLinks && <div>
            <p style={{ marginTop: 0, paddingTop: 0 }}>
              Life stage: {this.props.lifeStage !== 0 ? lifeStageOptions[this.props.lifeStage - 1].label : "Not Selected"}
              <Link className="account-image-link ml-4" to="/accountsetting">
                Edit
              </Link>
            </p>
          </div>}
        </div>

        <Modal
          isOpen={this.state.modal}
          toggle={this.props.onClose}
          className="lg"
          style={{ width: "100%", maxWidth: this.props.imageHeight }}
        >
          <ModalHeader toggle={this.props.onClose}>Crop Image</ModalHeader>
          <ModalBody />
          <Cropper
            ref="cropper"
            src={this.state.cropImage}
            style={{ height: 350, width: "100%" }}
            aspectRatio={10/10}
            guides={false}
            cropBoxResizable={false}
            crop={this._crop.bind(this)}
            viewMode={2}
            // crop={this.props.handleSubmit}
          />
        
          <ModalFooter>
            <Button color="primary" onClick={this.handleCroppedImage}>Submit</Button>{' '}
            <Button color="secondary" onClick={this.toggle}>Cancel</Button>
          </ModalFooter>
        </Modal>

      </div>

    )
  }
}

export default MyProfile


// WEBPACK FOOTER //
// ./src/views/Account/MyProfile.js